import { PublicClientApplication, LogLevel } from '@azure/msal-browser';
import type { Configuration, RedirectRequest } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string;
const redirectUriEnv = (import.meta.env.VITE_ENTRA_REDIRECT_URI as string | undefined)?.trim();
const redirectUri = redirectUriEnv && redirectUriEnv.length > 0
  ? redirectUriEnv
  : `${window.location.origin}/auth/callback`;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'localStorage'
  },
  system: {
    // Popup do "Continuar conectado": tempo para digitar a senha e confirmar o MFA. O padrão é 60s, e
    // o MSAL v5 não percebe quando a pessoa fecha o popup: o erro só aparece no fim deste prazo.
    popupBridgeTimeout: 2 * 60 * 1000,
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false
    }
  }
};

export const loginRequest: RedirectRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read']
};

export const msalInstance = new PublicClientApplication(msalConfig);
